import { SVGProps, Ref, forwardRef } from 'react';

export const CalendarFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M6.6 1v2.299C3.073 3.86 1.7 5.375 1.222 9.1h21.556c-.479-3.725-1.851-5.239-5.378-5.801V1h-1.8v2.101A52 52 0 0 0 12 3c-1.358 0-2.551.027-3.6.101V1z"
                fill="currentColor"
            />
            <path
                d="M22.935 10.9H1.065A49 49 0 0 0 1 13c.103 8.721 1.714 10 11 10s10.897-1.279 11-10a49 49 0 0 0-.065-2.1"
                fill="currentColor"
            />
        </g>
    </svg>
));
CalendarFilledSize24Glyph.displayName = 'CalendarFilledSize24Glyph';
